<template>
  <div class="pe-root">
    <h1 class="pe-section-title">Histórico</h1>

    <!-- Totais principais -->
    <div class="pe-row">
      <div class="pe-kpi pe-kpi--orange">
        <span class="pe-kpi-label">Total Visitas</span>
        <span class="pe-kpi-val pe-kpi-val--white">{{
          cliente.visitas_total || 0
        }}</span>
      </div>
      <div class="pe-kpi pe-kpi--dark">
        <span class="pe-kpi-label pe-kpi-label--white">Total Faturação</span>
        <span class="pe-kpi-val pe-kpi-val--white">{{
          formatarEuro(cliente.gasto_total)
        }}</span>
      </div>
      <div class="pe-kpi">
        <span class="pe-kpi-label">Ticket Médio</span>
        <span class="pe-kpi-val">
          <template v-if="Number(cliente.visitas_total) > 0">
            {{
              formatarEuro(
                Number(cliente.gasto_total) / Number(cliente.visitas_total),
              )
            }}
          </template>
          <template v-else>—</template>
        </span>
      </div>
    </div>

    <!-- Visitas por período -->
    <div class="pe-row pe-row--sm">
      <div class="pe-kpi pe-kpi--sm">
        <span class="pe-kpi-label">Visitas 30 dias</span>
        <span class="pe-kpi-val pe-kpi-val--sm">{{
          cliente.visitas_30_dias || 0
        }}</span>
      </div>
      <div class="pe-kpi pe-kpi--sm">
        <span class="pe-kpi-label">Visitas 90 dias</span>
        <span class="pe-kpi-val pe-kpi-val--sm">{{
          cliente.visitas_90_dias || 0
        }}</span>
      </div>
      <div class="pe-kpi pe-kpi--sm">
        <span class="pe-kpi-label">Visitas 180 dias</span>
        <span class="pe-kpi-val pe-kpi-val--sm">{{
          cliente.visitas_180_dias || 0
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PerfilEstatisticas",
    props: { cliente: { type: Object, required: true } },
    methods: {
      formatarEuro(valor) {
        return new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(valor) || 0);
      },
    },
  };
</script>

<style scoped>
  .pe-root {
    margin-bottom: 16px;
  }
  .pe-section-title {
    font-size: 18px;
    font-weight: 800;
    color: #1a1210;
    letter-spacing: -0.3px;
    margin: 0 0 12px;
  }
  .pe-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }
  .pe-row--sm {
  }

  .pe-kpi {
    flex: 1;
    min-width: 140px;
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    padding: 18px 20px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.15s;
  }
  .pe-kpi:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07);
  }
  .pe-kpi--orange {
    background: #ff825d;
    border-color: #ff825d;
  }
  .pe-kpi--dark {
    background: #1a1210;
    border-color: #1a1210;
  }
  .pe-kpi--sm {
    padding: 14px 18px;
  }

  .pe-kpi-label {
    font-size: 11px;
    font-weight: 700;
    color: #b0a8a0;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
  .pe-kpi-label--white {
    color: rgba(255, 255, 255, 0.6);
  }
  .pe-kpi-val {
    font-size: 32px;
    font-weight: 800;
    color: #1a1210;
    letter-spacing: -1.5px;
    line-height: 1.1;
  }
  .pe-kpi-val--white {
    color: #fff;
  }
  .pe-kpi-val--sm {
    font-size: 26px;
  }

  @media (max-width: 768px) {
    .pe-kpi {
      min-width: calc(50% - 6px);
    }
  }
</style>
